import { render, staticRenderFns } from "./ReportMaintenance.vue?vue&type=template&id=354b51a7&"
import script from "./ReportMaintenance.vue?vue&type=script&lang=js&"
export * from "./ReportMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports